import React from "react";
import { HashLink } from "react-router-hash-link";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import { deleteDoc, doc, db } from "../../firebase";

const MessageBoardTable = (props) => {
  let boards = props.boards;

  const deleteMessage = async (id) => {
    if (window.confirm("이 글을 지우시겠습니까?")) {
      await deleteDoc(doc(db, "board", id));
      props.getBoards();
    }
  };
  return (
    <div>
      <table cellpadding="0" cellspacing="0" border="0">
        <colgroup>
          <col class="col-1" />
          <col class="col-7" />
          <col class="col-1" />
          <col class="col-2" />
          <col class="col-1" />
        </colgroup>
        <thead
          style={{
            borderBottom: "1px solid gray",
            width: "100%",
            height: "20px",
          }}
        >
          <tr>
            <th class="align-center">번호</th>
            <th class="align-center">제목</th>
            <th class="align-center">작성자</th>
            <th class="align-center">작성일</th>
            <th class="align-center">조회수</th>
          </tr>
        </thead>
        <tbody>
          {boards.map((board, idx) => {
            return (
              <>
                <tr>
                  <td class="align-center">{boards.length - idx}</td>
                  <td class="align-left" style={{ display: "flex" }}>
                    <Box className="pink_link" sx={{ mr: 1 }}>
                      <HashLink to={"/admin/board_modify/" + board.id}>
                        수정
                      </HashLink>
                    </Box>
                    <Box
                      className="pink_link"
                      onClick={() => deleteMessage(board.id)}
                      sx={{ mr: 1, cursor: "pointer" }}
                    >
                      삭제
                    </Box>
                    <Box className="pink_link" sx={{ mr: 1 }}>
                      <HashLink
                        target={"_blank"}
                        to={"/message-board/" + board.id}
                      >
                        글 조회
                      </HashLink>
                    </Box>

                    <div dangerouslySetInnerHTML={{ __html: board.title }} />
                  </td>

                  <td class="align-center">헤즐릿</td>
                  <td class="align-center">
                    {board?.created &&
                      board?.created?.toDate().toLocaleDateString("fr-CA", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })}
                  </td>
                  <td class="align-center">{board.viewed}</td>
                </tr>
              </>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default MessageBoardTable;
